import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import { TransferTask, useTransferQueue } from "./app/transferQueue";
import { humanReadableSize } from "./app/utils";
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  ErrorOutline as ErrorOutlineIcon,
} from "@mui/icons-material";

function ProgressDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [tab, setTab] = useState(0);
  const transferQueue: TransferTask[] = useTransferQueue();

  const tasks = useMemo(() => {
    const taskType = tab === 0 ? "download" : "upload";
    return Object.values(transferQueue).filter(
      (task) => task.type === taskType
    );
  }, [tab, transferQueue]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Progress</DialogTitle>
      <Tabs
        value={tab}
        onChange={(_, newTab) => setTab(newTab)}
        sx={{ "& .MuiTab-root": { flexBasis: "50%" } }}
      >
        <Tab label="Downloads" />
        <Tab label="Uploads" />
      </Tabs>
      {tasks.length === 0 ? (
        <DialogContent>
          <Typography textAlign="center" color="text.secondary">
            No tasks
          </Typography>
        </DialogContent>
      ) : (
        <DialogContent sx={{ padding: 0 }}>
          <List>
            {tasks.map((task) => {
              const pct =
                task.total > 0
                  ? Math.min(100, Math.round((task.loaded / task.total) * 100))
                  : 0;
              return (
                <ListItem key={task.name}>
                  <ListItemText
                    primary={task.name}
                    secondary={`${humanReadableSize(
                      task.loaded
                    )} / ${humanReadableSize(task.total)} · ${pct}%`}
                  />
                  {task.status === "failed" ? (
                    <Tooltip title={task.error.message}>
                      <ErrorOutlineIcon color="error" />
                    </Tooltip>
                  ) : task.status === "completed" ? (
                    <CheckCircleOutlineIcon color="success" />
                  ) : task.status === "in-progress" ? (
                    <CircularProgress
                      variant="determinate"
                      size={24}
                      value={pct}
                    />
                  ) : null}
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
      )}
    </Dialog>
  );
}

export default ProgressDialog;
